import {UntypedFormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Directive, Inject} from "@angular/core";


@Directive()
export abstract class DialogBase<T> {
  dialogForm: UntypedFormGroup;

  protected constructor(public dialogRef: MatDialogRef<T>,
                        @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
  }

  abstract _initForm();

  ngOnInit(): void {
    this._initForm();
  }

  onSubmit(): void {
    if (this.dialogForm.invalid) {
      return;
    }
    this.dialogRef.close(this.dialogForm.value);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
